import { cloneObject } from "../utils/utils";
import JSZip from "jszip";


export const addInterface = (dsd, Data = {}, onAdd, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadInterface(Data)

    dsd.httpConfig.post(`/interfaces`, payload, headers)
        .then(response => {
            if (onAdd){
                onAdd(response.data._id)
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;
}

export const editInterface = (dsd, id = null, Data = {}, onUpdate, onError) => {
    
    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }


    let payload = payloadInterface(Data)

    dsd.httpConfig.put(`/interfaces/${id}`, payload, headers)
        .then(response => {
            if (onUpdate){
                onUpdate();
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return true;
};

function payloadInterface(data){

    let payload = {}
    payload.name = data.name;
    payload.description = data.description;
    payload.proposals = data.proposals;
    payload.status = data.status;
    payload.DataSpecs = data.DataSpecs;

    return payload;

}

function dataInterface(data){

    let obj = data;

    return obj;

}

export const getInterface = (dsd, id=null, onLoad=null, onFail=null, representation="dsd", format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/interfaces/${id}?`

        if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};




export const listInterfaces = (dsd, Filters={}, onLoad, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/interfaces"
    if (Object.keys(Filters).length > 0){
        urlAPI += "?"
    }
    
    if (Filters.idUser){
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.scope){
        urlAPI += `scope=${encodeURIComponent(Filters.scope)}&`;
    }

    if (Filters.status){
        urlAPI += `status=${encodeURIComponent(Filters.status)}&`;
    }

    if (Filters.search){
        urlAPI += `search=${encodeURIComponent(Filters.search)}&`;
    }
    
    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {

            let arr = [];
            for (let pos=0; pos<response.data.length;pos++){
                arr.push(dataInterface(response.data[pos]));
            }
            if (onLoad){
                onLoad(arr);
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;

};

export const getInterfaceVersion = (dsd, id=null, idVersion = null, onLoad=null, onFail=null, representation='dsd', format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/interfaces/${id}/version/${idVersion}?`

    if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};

export const getInterfaceVersionSerializations = (dsd, id=null, idVersion = null, onLoad=null, onFail=null, representation='dsd', format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/interfaces/${id}/version/${idVersion}/serializations?`

    if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};

export const addMethodToInterface = (dsd, idInterface, Data = {}, onAdd, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = makeMethodPayload(Data)

    dsd.httpConfig.post(`/interfaces/${idInterface}/methods`, payload, headers)
        .then(response => {
            if (onAdd){
                onAdd(response.data._id)
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });
}
    
    
export const editMethod = (dsd, id = null, Data = {}, onUpdate, onError) => {
    
    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }


    let payload = makeMethodPayload(Data)
    let idInterface = null;
    if (Data.Interface) {
        idInterface = Data.Interface._id;
    }

    dsd.httpConfig.put(`/interfaces/${idInterface}/methods/${id}`, payload, headers)
        .then(response => {
            if (onUpdate){
                onUpdate();
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });
};
    
export const deleteMethod = (dsd, idInterface, id, onDelete, onError) => {
    
    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    dsd.httpConfig.delete(`/interfaces/${idInterface}/methods/${id}`, headers)
        .then(response => {
            onDelete();
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

}
    
    
function makeMethodPayload(inData){
    
        let data = cloneObject(inData)
    
        let payload = {}
        payload.name = data.name;
        payload.action = data.action;

        payload.idSerialization = null;
        if (data.idSerialization){
            payload.idSerialization = data.idSerialization;
        }

        payload.Path = []
        if (Array.isArray(data.Path)){
            payload.Path = data.Path;
        }

        payload.Parameters = []
        if (Array.isArray(data.Parameters)){
            payload.Parameters = data.Parameters;
        }

        payload.Responses = []
        if (Array.isArray(data.Responses)){
            payload.Responses = data.Responses;
        }

        payload.description = data.description;
        payload.proposals = data.proposals;
    
        return payload;
    
    }
    
export const getMethod = (dsd, id = null, onLoad, onFail) => {
    
    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    dsd.httpConfig.get(`/methods/${id}`, headers)
        .then(response => {
            if (onLoad){
                onLoad(makeMethodData(response.data));
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        });

    return;

};
    
export const listMethods = (dsd, Filters={}, onLoad, onError) => {
    
    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/methods"
    if (Object.keys(Filters).length > 0){
        urlAPI += "?"
    }
    
    if (Filters.idUser){
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.idInterface){
        urlAPI += `idInterface=${encodeURIComponent(Filters.idInterface)}&`;
    }

    
    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {

            let arr = [];
            for (let pos=0; pos<response.data.length;pos++){
                arr.push(makeMethodData(response.data[pos]));
            }
            if (onLoad){
                onLoad(arr);
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;

};
    
       
function makeMethodData(data){
    
    let obj = data;

    return obj;

}




export const addParameterToInterface = (dsd, idInterface, Data = {}, onAdd, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = makeParameterPayload(Data)

    dsd.httpConfig.post(`/interfaces/${idInterface}/parameters`, payload, headers)
        .then(response => {
            if (onAdd){
                onAdd(response.data._id)
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });
}


export const editParameter = (dsd, id, Data = {}, onUpdate, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }


    let payload = makeParameterPayload(Data)
    let idInterface = null;
    if (Data.Interface) {
        idInterface = Data.Interface._id;
    }

    dsd.httpConfig.put(`/interfaces/${idInterface}/parameters/${id}`, payload, headers)
        .then(response => {
            if (onUpdate){
                onUpdate();
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });
};


export const deleteParameter = (dsd, idInterface, id, onDelete, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    dsd.httpConfig.delete(`/interfaces/${idInterface}/parameters/${id}`, headers)
        .then(response => {
            onDelete();
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

}


function makeParameterPayload(inData){

    let data = cloneObject(inData)

    let payload = {}
    payload.name = data.name;
    payload.dataType = data.dataType;
    payload.values = data.values;

    payload.description = data.description;
    payload.proposals = data.proposals;

    return payload;

}

export const getParameter = (dsd, id=null, onLoad=null, onFail=null, representation="dsd", format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/parameters/${id}?`

        if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );


};


export const listParameters = (dsd, Filters={}, onLoad, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/parameters"
    if (Object.keys(Filters).length > 0){
        urlAPI += "?"
    }
    
    if (Filters.idUser){
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.idInterface){
        urlAPI += `idInterface=${encodeURIComponent(Filters.idInterface)}&`;
    }

 
    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {

            let arr = [];
            for (let pos=0; pos<response.data.length;pos++){
               arr.push(makeParameterData(response.data[pos]));
            }
            if (onLoad){
                onLoad(arr);
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;

};



function makeParameterData(data){

    let obj = data;

    return obj;

}

export const zipInterface = async function(dsd, Interface){

    const zip = new JSZip();

    let Promises = [];

    let Version = null;
    let idVersion = null;
    if (Interface.Version){
        Version = Interface.Version;
        idVersion = Version._id;
    }

    let nameFolder = `interface_${Interface._id}`;
    if (Version){
        nameFolder += `_version_${idVersion}`;
    }

    let strInterface = JSON.stringify(Interface, null, 4);
    zip.file(`${nameFolder}/dsd.json`, strInterface);

    let dsdSerializations = {};

    let oad = null;
    let dotSerializations = {};
    let svgSerializations = {};


    const onDoneOad = function(reply){
        oad = reply;
        return;
    };

    const onDoneDsdSerializations = function(reply){
        dsdSerializations = reply;
        return;
    };


    const onDoneDotSerializations = function(reply){
        dotSerializations = reply;
        return;
    };

    const onDoneSvgSerializations = function(reply){
        svgSerializations = reply;
        return;
    };


    Promises.push(getInterfaceVersion(dsd,Interface._id,idVersion, onDoneOad, null,'oad'));
    Promises.push(getInterfaceVersionSerializations(dsd,Interface._id,idVersion, onDoneDsdSerializations, null,'dsd'));
    Promises.push(getInterfaceVersionSerializations(dsd,Interface._id,idVersion, onDoneDotSerializations, null,'dot'));
    Promises.push(getInterfaceVersionSerializations(dsd,Interface._id,idVersion, onDoneSvgSerializations, null,'image'));



    return(
        Promise.all(Promises)
        .then(async response => {
            if (oad){
                zip.file(`${nameFolder}/openapi.oad`, JSON.stringify(oad, null, 4));
            }

            for (const idSerialization in dsdSerializations){
                const Serialization = dsdSerializations[idSerialization];
                
                const strSerialization = JSON.stringify(Serialization,null,4);
                zip.file(`${nameFolder}/serializations/${Serialization._id}/dsd.json`, strSerialization);

                const dotSerialization = dotSerializations && dotSerializations[Serialization._id];
                if (dotSerialization) zip.file(`${nameFolder}/serializations/${Serialization._id}/viz.dot`, dotSerialization);

                const svgSerialization = svgSerializations && svgSerializations[Serialization._id];
                if (svgSerialization) zip.file(`${nameFolder}/serializations/${Serialization._id}/image.svg`, svgSerialization);

            }

            const zipData = await zip.generateAsync({
                type: "blob",
                streamFiles: true,
            })
        
            return zipData;    

        })
    )

};
